import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PurchaseReturnForm } from "@/features/purchase-returns";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreatePurchaseReturn = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      // Extract buyerId for header, remove it from payload
      const { buyerId, ...payload } = formData;

      await apiOutletClient.post("purchase-returns", payload, {
        headers: {
          "Outlet-Id": buyerId,
        },
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat retur pembelian")
      );

      throw error;
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Retur Pembelian"
      breadcrumbs={[
        { title: "Retur Pembelian", path: "/procurement/purchase-returns" },
        { title: "Tambah" },
      ]}
    >
      <PurchaseReturnForm
        onSubmit={handleSubmit}
        defaultValues={{
          buyer: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
